import React, { useState } from "react";
import "./VolunteerForm.css";
import { AiOutlineClose } from "react-icons/ai";

import { ENDPOINTS } from "../../endpoint";

const VolunteerForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    email: "",
    phone: "",
    location: "",
    education: "",
    contribution: "",
  });
  const [loading, setLoading] = useState(false);
  // msg will be: { type: 'success' | 'error', text: string } or null
  const [msg, setMsg] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg(null);

    if (!formData.name || !formData.email || !formData.contribution) {
      setMsg({
        type: "error",
        text: "Please fill Full Name, Email, and Contribution.",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
        ENDPOINTS.SEND_EMAIL,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            full_name: formData.name,
            age: formData.age || undefined,
            email: formData.email,
            phone: formData.phone || undefined,
            location: formData.location || undefined,
            education: formData.education || undefined,
            contribution: formData.contribution,
          }),
        }
      );

      const ct = res.headers.get("content-type") || "";
      const data = ct.includes("application/json") ? await res.json() : {};

      if (!res.ok) {
        throw new Error(data?.message || "Failed to submit. Try again.");
      }

      setMsg({ type: "success", text: "Thanks! We received your enquiry." });
      // Keep form open; user will close it
    } catch (err) {
      setMsg({ type: "error", text: err.message || "Something went wrong." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="volunteer-form-wrapper">
      <div className="volunteer-form-overlay">
        <div className="volunteer-form-container">
          <div className="volunteer-form-close" onClick={onClose}>
            <AiOutlineClose />
          </div>

          <h3 className="volunteer-heading">Enquire</h3>

          {msg && (
            <div
              className={`vf-alert ${
                msg.type === "success" ? "vf-success" : "vf-error"
              }`}
            >
              <span className="vf-alert-icon" aria-hidden>
                {msg.type === "success" ? (
                  <svg viewBox="0 0 24 24" width="18" height="18">
                    <path
                      d="M9 12l2 2 4-4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" width="18" height="18">
                    <path
                      d="M12 9v4m0 4h.01M10.29 3.86l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.71-3.14l-8-14a2 2 0 0 0-3.42 0z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </span>
              <span className="vf-alert-text">{msg.text}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="volunteer-form">
            <input
              name="name"
              type="text"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              name="age"
              type="number"
              placeholder="Age"
              value={formData.age}
              onChange={handleChange}
            />
            <input
              name="email"
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              name="phone"
              type="tel"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
            />
            <input
              name="location"
              type="text"
              placeholder="Location"
              value={formData.location}
              onChange={handleChange}
            />
            <input
              name="education"
              type="text"
              placeholder="Education"
              value={formData.education}
              onChange={handleChange}
            />
            <textarea
              name="contribution"
              placeholder="How can you contribute?"
              value={formData.contribution}
              onChange={handleChange}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VolunteerForm;
